import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-desempenho", {
        attrs: { titulo: "Desempenho Técnico" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VCol,
                  { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                  [
                    !_vm.prazoDisponivel
                      ? _c(
                          VRow,
                          [
                            _c(
                              VCol,
                              [
                                _c("app-alert", {
                                  attrs: {
                                    icon: "watch_later",
                                    message:
                                      "O prazo para visualização ainda não está disponível.",
                                    type: "info",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _vm.desempenhoLoaded
                              ? _c(
                                  VRow,
                                  { staticClass: "justify-center ma-2" },
                                  [
                                    _c(
                                      VTabs,
                                      {
                                        attrs: {
                                          centered: "",
                                          "icons-and-text": "",
                                        },
                                        model: {
                                          value: _vm.currentCategoriaId,
                                          callback: function ($$v) {
                                            _vm.currentCategoriaId = $$v
                                          },
                                          expression: "currentCategoriaId",
                                        },
                                      },
                                      [
                                        _c(VTabsSlider, {
                                          attrs: { color: "secondary" },
                                        }),
                                        _vm._l(_vm.categorias, function (c) {
                                          return _c(
                                            VTab,
                                            {
                                              key: c.id,
                                              staticClass: "mt-3",
                                              attrs: { href: `#${c.id}` },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "grey--text text--darken-2",
                                                },
                                                [_vm._v(_vm._s(c.descricao))]
                                              ),
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    color:
                                                      c.id ===
                                                      _vm.currentCategoriaId
                                                        ? "secondary"
                                                        : "grey",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(c.icone) + " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.desempenhoLoaded
                              ? _c(
                                  VRow,
                                  { staticClass: "justify-center ma-2" },
                                  [
                                    _vm.teveAvaliacao
                                      ? _c(
                                          VCol,
                                          [
                                            _c(
                                              "keep-alive",
                                              [
                                                _c(_vm.currentComponent, {
                                                  key: _vm.currentCategoria.id,
                                                  tag: "component",
                                                  attrs: {
                                                    desempenho: _vm.desempenho,
                                                    tipo: _vm.currentCategoria
                                                      .id,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          VCol,
                                          [
                                            _c("app-alert", {
                                              attrs: {
                                                message:
                                                  _vm.motivoNaoTeveAvaliacao,
                                                type: "info",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }